import React from "react"
import {
  Card,
  CardHeader,
  CardBody,
  Row,
  Col,
  Badge,
  Input,
  Button
} from "reactstrap"
import moment from "moment"
import { BackButton } from "components/utility"
import {
  orderStatusTypes,
  deliveryTypes,
  findTypeValueByKey
} from "utils/types"
import DetailHeaderContent from "./DetailHeaderContent"

const DetailHeader = ({
  data,
  onCustomOrderNumberChange,
  onCustomOrderNumberSave
}) => (
  <Card>
    <CardHeader>
      <Row style={{ display: "flex", alignItems: "center" }}>
        <Col>
          <i className="mdi mdi-file mr-2"> </i> 購買資訊
        </Col>
        <Col>
          <BackButton />
        </Col>
      </Row>
    </CardHeader>
    <CardBody>
      <Row>
        <Col>
          <DetailHeaderContent
            title="公司名稱"
            content={data?.order?.company?.name}
          />
        </Col>
      </Row>
      {onCustomOrderNumberChange && (
        <Row>
          <Col>
            <div>
              <div style={titleStyle}>
                公司訂單號碼 (如發票需註明訂單號碼，請務必填寫此欄位)
              </div>
              <div className="d-flex flex-nowrap mt-2 mb-2">
                <Input
                  style={{ width: "200px" }}
                  defaultValue={data?.order?.clientOrderNumber}
                  onChange={onCustomOrderNumberChange}
                />
                <Button
                  color="success"
                  onClick={onCustomOrderNumberSave}
                  className="ml-2 mr-2"
                >
                  更新公司訂單號碼
                </Button>
              </div>
            </div>
          </Col>
        </Row>
      )}
      <Row>
        <Col>
          <DetailHeaderContent
            title="發票編號"
            content={data?.order?.invoiceNumber || "未提供"}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <DetailHeaderContent
            title="宅配單號"
            content={
              data?.order?.deliveryNumber ? (
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href={`https://www.t-cat.com.tw/Inquire/Trace.aspx?no=${data?.order?.deliveryNumber}`}
                >
                  {data?.order?.deliveryNumber}
                </a>
              ) : (
                "未提供"
              )
            }
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <DetailHeaderContent
            title="巨研訂單編號"
            content={data?.order?.orderNumber || "(草稿) 尚未成單"}
          />
        </Col>
      </Row>
      <Row>
        <Col xs={6}>
          <DetailHeaderContent
            title="購買人"
            content={data?.order?.user?.name}
          />
        </Col>
        <Col xs={6}>
          <DetailHeaderContent
            title="訂購日期"
            content={
              data?.order?.submittedTime
                ? moment(data?.order?.submittedTime).format("YYYY-MM-DD a h:mm")
                : "(草稿) 尚未成單"
            }
          />
        </Col>
      </Row>
      <Row>
        <Col xs={6}>
          <DetailHeaderContent
            title="訂單總額"
            content={data?.order?.totalAmount || "待議價"}
          />
        </Col>
        <Col xs={6}>
          <DetailHeaderContent
            title="狀態"
            content={
              <Badge color="success" pill style={{ color: "#FFF" }}>
                {data?.order?.status &&
                  findTypeValueByKey(orderStatusTypes, data.order.status)}
              </Badge>
            }
          />
        </Col>
        <Col xs={6}>
          <DetailHeaderContent
            title="出貨方式"
            content={
              data?.order?.deliveryType &&
              findTypeValueByKey(deliveryTypes, data.order.deliveryType)
            }
          />
        </Col>
        <Col xs={6}>
          <DetailHeaderContent
            title="發票電子檔"
            content={
              (data.order.invoiceUrl && (
                <a
                  href={`http://VIP.getech.com.tw:6000/download?file=http://${data.order.invoiceUrl}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  下載發票
                </a>
              )) ||
              "未提供"
            }
          />
        </Col>
      </Row>
    </CardBody>
  </Card>
)

const titleStyle = {
  fontWeight: "bold"
}

// const contentStyle = {
//   marginBottom: "5px",
//   marginTop: "5px"
// }

export default DetailHeader
